import React, { useContext } from 'react'
import { AppContext, SettingsContext } from '../../../mtska-frontend-app-scaffolding'
import { Box } from '@mui/joy'
import { LegalEntitySelect } from './LegalEntitySelect'
import { Text } from '../Typography'

const LegalEntitySelector = () => {

    // const { appConfiguration } = useContext(AppContext)

    // const legalEntitySelectProps = { filterByLegalEntity, onChange, options }

    return (
        <>
            <LegalEntitySelect />

            {/* {appConfiguration?.legalEntitySelector?.active && settings && !filterByLegalEntity && (
                <Box className="dialog dialog-confirm">
                    <Box className="dialog-backdrop" />
                    <Box className="dialog-content">
                        <Text level="h3">{appConfiguration?.legalEntitySelector?.title}</Text>
                        <p>{appConfiguration?.legalEntitySelector?.subtitle}</p>
                        <Text level="body-md">
                            <LegalEntitySelect {...legalEntitySelectProps} />
                        </Text>
                    </Box>
                </Box>
            )} */}
        </>
    )
}

export default LegalEntitySelector